import { Injectable } from '@angular/core';
import { GridService } from './grid.service';
import { DictionaryService } from './dictionary.service';
import { SharedService } from './shared.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CampaignsService {
  public assignedColumnsSettings: Array<any>;
  public assignmentTypes: Array<any>;
  public defaultCampaignParams: any;

  constructor(
    public dictionaryService: DictionaryService,
    private gridService: GridService,
    private sharedService: SharedService
  ) {
    this.assignedColumnsSettings = [
      { key: '$$selected', label: 'ASSIGNED', width: 192, resizable: true },
      { key: 'active', label: 'ACTIVE' },
      { key: 'id', label: 'ITEM_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'ITEM_NAME', filterType: 'INPUT' },
      {
        key: 'environment',
        label: 'ENVIRONMENT_SHORT',
        filterType: 'SELECT',
        parseFunction: this.gridService.parseMultipleEnvironments,
        parseTooltipFunction: this.gridService.parseMultipleEnvironmentsTooltip,
      },
      { key: 'type', label: 'TYPE', filterType: 'SELECT' },
      { key: 'partner', label: 'PARTNER_NAME', filterType: 'SELECT' },
    ];

    this.assignmentTypes = [
      {
        id: 2,
        label: this.dictionaryService.get('SUPPLY') + ' ' + this.dictionaryService.get('ITEMS_CAP'),
        name: 'supply',
      },
      {
        id: 3,
        label: this.dictionaryService.get('DEMAND') + ' ' + this.dictionaryService.get('ITEMS_CAP'),
        name: 'demand',
      },
    ];

    this.defaultCampaignParams = {
      id: -1,
      name: '',
      active: true,
      startDate: this.getDate(),
      startTime: 0,
      endDate: this.getDate(),
      endTime: 23,
      type: 3,
      daily: '',
      hourly: '',
      assignmentType: 1,
    };
  }

  getDate(dateString: string = '') {
    let date: any;
    const tzOffset: number = this.sharedService.offsetEST;
    date = new Date(dateString);

    if (dateString === '' || date.toString() === 'Invalid Date') {
      date = moment().utc().utcOffset(tzOffset);
    } else {
      date = moment(dateString);
    }

    return new Date(date.year(), date.month(), date.date());
  }

  getHour(dateString: string = '') {
    let date: any;
    date = new Date(dateString);

    return dateString === '' || date.toString() === 'Invalid Date' ? 0 : date.getHours();
  }

  getCampaignType(type: number) {
    const dictionaryService: DictionaryService = new DictionaryService();
    let resp = '-';

    switch (type) {
      case 2:
        resp = dictionaryService.get('SUPPLY');
        break;

      case 3:
        resp = dictionaryService.get('DEMAND');
        break;
    }

    return resp;
  }

  getCurrencyString(type: number) {
    let resp = '';

    switch (type) {
      case 1:
        resp = '$';
        break;
    }

    return resp;
  }

  parseFloat(number: any) {
    if (number === undefined || number === null || number === '' || isNaN(Number(number))) {
      number = 0;
    }
    return parseFloat(number).toFixed(2);
  }

  getRunningState(row: any) {
    let now: any = new Date();
    now = (now.getTime() + now.getTimezoneOffset() * 60000) / 1000 + this.sharedService.offsetEST * 60;
    const start = row.b_s ? new Date(row.b_s) : new Date(row.start);
    const end = row.b_e ? new Date(row.b_e) : new Date(row.end);

    if ([start.toString(), end.toString()].includes('Invalid Date')) { return false; }

    return (row.active === '1' || row.b_a === '1') && now > start.getTime() / 1000 && now < end.getTime() / 1000;
  }

  isCampaignFinished(row: any) {
    let now: any = new Date();
    now = (now.getTime() + now.getTimezoneOffset() * 60000) / 1000 + this.sharedService.offsetEST * 60;
    const end = new Date(row.end);

    if ([end.toString()].includes('Invalid Date')) { return false; }

    return now > end.getTime() / 1000;
  }
}
